import * as theme from '../../../theme';
import dayjs from 'dayjs';
import TruCard from '../../TruCard';
import TrainingContentItem from '../items/TrainingContentItem';
import TrainingContentContext from '../../../contexts/TrainingContentContext';

export default function TrainingContentList({ training, currentUser, setActiveContent, onComplete }) {

  return (
    <TruCard title={'Training Content'}>
      {TrainingContentContext.map((item) => (
        <TrainingContentItem
          key={item.action}
          action={item.action}
          icon={item.type}
          label={item.title}
          isComplete={training[item.action]?.dateCompleted}
          content={
            training[item.action]?.dateCompleted
              ? dayjs(training[item.action].dateCompleted.toDate()).format('MM/DD/YYYY h:mm A')
              : null
          }
          actionLink={() => setActiveContent(item)}
          canComplete={currentUser.role === 'practitioner'}
          onComplete={onComplete}
        />
      ))}
    </TruCard>
  );
}